// Action Types
export const FETCH_MARKET_DATA_REQUEST = 'FETCH_MARKET_DATA_REQUEST';
export const FETCH_MARKET_DATA_SUCCESS = 'FETCH_MARKET_DATA_SUCCESS';
export const FETCH_MARKET_DATA_FAILURE = 'FETCH_MARKET_DATA_FAILURE';
export const START_MARKET_DATA_POLLING = 'START_MARKET_DATA_POLLING';
export const STOP_MARKET_DATA_POLLING = 'STOP_MARKET_DATA_POLLING';
export const UPDATE_SINGLE_MARKET_DATA = 'UPDATE_SINGLE_MARKET_DATA';

// Action Creators
export const fetchMarketDataRequest = (tab, symbolTokensArray) => ({
    type: FETCH_MARKET_DATA_REQUEST,
    payload: { tab, symbolTokensArray }
});

export const fetchMarketDataSuccess = (data) => ({
    type: FETCH_MARKET_DATA_SUCCESS,
    payload: data
});

export const fetchMarketDataFailure = (error) => ({
    type: FETCH_MARKET_DATA_FAILURE,
    payload: error
});

export const startMarketDataPolling = (tab, symbolTokensArray, interval = 1000) => ({
    type: START_MARKET_DATA_POLLING,
    payload: { tab, symbolTokensArray, interval }
});

export const stopMarketDataPolling = () => ({
    type: STOP_MARKET_DATA_POLLING
});

export const updateSingleMarketData = (symbolToken, data) => ({
    type: UPDATE_SINGLE_MARKET_DATA,
    payload: { symbolToken, data }
});

// Initial State
const initialState = {
    marketData: [],
    loading: false,
    error: null,
    isPolling: false,
    lastUpdated: null,
    priceUpdates: {}, // Store individual price updates by symbolToken
    currentSymbol: null // Track current symbol being watched
};

// Reducer
const addOrderReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MARKET_DATA_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_MARKET_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                marketData: action.payload,
                error: null,
                lastUpdated: new Date().toISOString()
            };

        case FETCH_MARKET_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                isPolling: false
            };

        case START_MARKET_DATA_POLLING:
            return {
                ...state,
                isPolling: true,
                error: null,
                currentSymbol: action.payload.symbolTokensArray[0]?.token || null
            };

        case STOP_MARKET_DATA_POLLING:
            return {
                ...state,
                isPolling: false,
                currentSymbol: null
            };

        case UPDATE_SINGLE_MARKET_DATA:
            const { symbolToken, data } = action.payload;
            return {
                ...state,
                marketData: state.marketData.map(item =>
                    String(item.symbolToken) === String(symbolToken)
                        ? { ...item, ...data }
                        : item
                ),
                priceUpdates: {
                    ...state.priceUpdates,
                    [symbolToken]: {
                        ...data,
                        timestamp: new Date().toISOString()
                    }
                },
                lastUpdated: new Date().toISOString()
            };

        default:
            return state;
    }
};

export default addOrderReducer;